import tw from 'tailwind-styled-components'

const dialogPanel = `
w-full 
max-w-[565px] 
h-[326px] 
transform 
overflow-hidden 
rounded-2xl 
bg-white 
p-8 
text-left 
align-middle 
shadow-xl 
transition-all
`

const dialogTitle = `
text-lg 
font-medium 
leading-6 
text-gray-900
flex
justify-between
`

export const cancelButton = `
text-white 
bg-blueTheme
p-4 
`

export const confirmButton = `
p-4 
text-blueTheme
bg-white
border-blueTheme
`
export const title = `
text-yellow 
text-xl 
font-semibold 
justify-center 
flex
`


export { dialogPanel, dialogTitle }
